import createModel from 'utils/model'
import {
    sub,
    summary,
    usersSearch,
    usersIndependent,
    customersSuggest,
    getGroupList,
    saveGroup,
    editGroup,
    delGroup,
} from 'services/users'

export default createModel({
    namespace: 'users',
    state: {
        subUsers: [],
    },
    subscriptions: {},
    effects: {
        *sub({payload}, {call, put}) {
            const res = yield call(sub, payload.params)
            if (res && res.data) {
                const {data} = res
                yield put({
                    type: 'setProperty',
                    payload: {
                        subUsers: data,
                    },
                })
                return data
            }
        },
        *summary({payload}, {call}) {
            const res = yield call(summary, payload.params)
            if (res && res.data) {
                return res.data
            }
        },
        *usersSearch({payload}, {call}) {
            return yield call(usersSearch, payload)
        },
        *usersIndependent({payload}, {call}) {
            return yield call(usersIndependent, payload)
        },
        *customersSuggest({payload}, {call}) {
            return yield call(customersSuggest, payload)
        },

        *getGroupList({payload}, {call}) {
            return yield call(getGroupList, payload)
        },
        *saveGroup({payload}, {call}) {
            return yield call(saveGroup, payload)
        },
        *editGroup({payload}, {call}) {
            return yield call(editGroup, payload)
        },
        *delGroup({payload}, {call}) {
            return yield call(delGroup, payload)
        },
    },

    reducers: {
        setProperty(state, action) {
            return {...state, ...action.payload}
        },
    },
})
